import React from 'react';
import { useLoaderData } from 'react-router-dom';
import { graphql } from 'relay-runtime';
import { PreloadedQuery, usePreloadedQuery, useQueryLoader } from 'react-relay';
import Email from './Email';
import type {
  EmailPreloaderQuery as EmailPreloaderQueryType,
  EmailPreloaderQuery$data as EmailPreloaderQueryResponse,
} from './__generated__/EmailPreloaderQuery.graphql';

export const CreateAccountPrefillQuery = graphql`
  query EmailPreloaderQuery($email: String, $encryptedEmail: String) {
    hubspotLead(email: $email, encryptedEmail: $encryptedEmail) {
      email
      firstName
      lastName
    }
  }
`;

const EmailPreloader = () => {
  const loaderQueryReference = useLoaderData() as PreloadedQuery<
    EmailPreloaderQueryType,
    EmailPreloaderQueryResponse
  >;
  const [queryReference] = useQueryLoader<EmailPreloaderQueryType>(
    CreateAccountPrefillQuery,
    loaderQueryReference
  );
  const prefillData = usePreloadedQuery(
    CreateAccountPrefillQuery,
    queryReference as PreloadedQuery<
      EmailPreloaderQueryType,
      EmailPreloaderQueryType
    >
  );

  return (
    <Email
      email={prefillData.hubspotLead?.email}
      firstName={prefillData.hubspotLead?.firstName}
      lastName={prefillData.hubspotLead?.lastName}
    />
  );
};

export default EmailPreloader;
